import createReducer from '../../utils/createReducer';
import trendingCorridorDestinationsHandlers from './trendingCorridorDestinations';
import trustpilotHandlers from './trustpilot';

const initialState = {
  header: {},
  jumbotron: {},
  footer: {},
  sections: {},
  searchBox: {}
};

export default createReducer(initialState, {
  ...trendingCorridorDestinationsHandlers,
  ...trustpilotHandlers
});
